import { useState } from "react";
import PropTypes from "prop-types";
import { Form } from "./Form";
import { Errors } from "./Errors";
import { Checkbox } from "./Checkbox";
import { validate } from "./lib/validate";
import { subscribe } from "./lib/subscribe";
import { resolveMessage } from "./lib/resolve-message";
import { useForm } from "../../../hooks";
import { trackEvent } from "@lib/track-event";
import styles from "./styles/index.module.css";
import { useTranslation } from "next-i18next";
export function Waitlist({
  variantID,
  variantTitle,
  productTitle,
  buttonLabel,
  isComingSoon,
  waitlistMessage,
}) {
  const [thankYouMessage, setthankYouMessage] = useState(null);
  const emailKey = `email-waitlist`;
  const newsletterKey = `newsletter-waitlist`;
  const heading = resolveMessage(productTitle, variantTitle, isComingSoon, waitlistMessage);

  const { t } = useTranslation("productpage");

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setIsSubmitting,
    isSubmitting,
    serverError,
    setServerError,
  } = useForm(
    {
      [emailKey]: "",
      [newsletterKey]: true,
    },
    callback,
    validate
  );

  async function callback() {
    //TODO: add the numeric id as a property to the variant object
    const resolveId = () => {
      const values = variantID.split("/");
      return values[values.length - 1];
    };
    const result = await subscribe(values, emailKey, resolveId(), newsletterKey);
    setIsSubmitting(false);

    if (result.success) {
      trackEvent("identify", { email: values[emailKey] });
      trackEvent("generate_lead", { email: values[emailKey] });
      setthankYouMessage(variantTitle);
    } else {
      setServerError(result.message);
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h4 className={styles.label}>{heading}</h4>
        <Errors errors={errors} serverError={serverError} />
        <Checkbox
          id={newsletterKey}
          name={newsletterKey}
          value="newsletter"
          checked={values[newsletterKey]}
          onChange={handleChange}
        />
      </div>
      <Form
        values={values}
        emailKey={emailKey}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        isSubmitting={isSubmitting}
        buttonLabel={thankYouMessage === variantTitle ? t("on-list") : t(buttonLabel)}
      />
    </div>
  );
}

Waitlist.propTypes = {
  variantID: PropTypes.string.isRequired,
  variantTitle: PropTypes.string.isRequired,
  productTitle: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  isComingSoon: PropTypes.bool,
};

Waitlist.defaultProps = {
  buttonLabel: "join-waitlist",
  isComingSoon: false,
};
